import { Component } from "@angular/core";

@Component({
  selector: "jni-bc-gp-support-table",
  templateUrl: "./bc-gp-support-table.component.html",
  styleUrls: ["./bc-gp-support-table.component.scss"],
})
export class BcGpSupportTableComponent {}
